import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Rate,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Image,
} from "antd";
import { Rule } from "antd/lib/form";
import Column from "antd/lib/table/Column";
import { productRateApi } from "api/productRate.api";
import { staffApi } from "api/staff.api";
import { Pagination } from "components/Pagination";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { Product } from "types/product";
import { ProductRate } from "types/product-rate";
import { QueryParam } from "types/query";
import { $url } from "utils/url";

const rules: Rule[] = [{ required: true }];
const { Option } = Select;

interface ProductRateQuery extends QueryParam {
  star: number | null;
  isHasImage?: boolean;
}

export const ProductRateModal = ({
  visible,
  status,
  product,
  onClose,
}: {
  visible: boolean;
  status: ModalStatus;
  product: Partial<Product>;
  onClose: () => void;
}) => {
  const [query, setQuery] = useState<ProductRateQuery>({
    page: 1,
    limit: 50,
    search: "",
    star: null,
  });

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ProductRate[]>([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (status == "create" && visible) {
    }
  }, [visible, status]);

  useEffect(() => {
    if (product?.id) {
      fetchData();
    }
  }, [product]);

  const fetchData = async () => {
    setLoading(true);
    const res = await productRateApi.findAll({
      ...query,
      productId: product.id,
    });
    setLoading(false);
    setData(res.data.productRates);
    setTotal(res.data.total);
  };

  const handleDelete = async (rate: ProductRate) => {
    setLoading(true);
    try {
      await productRateApi.delete(rate.id);
      fetchData();
      message.success("Xóa thành công");
    } finally {
      setLoading(false);
    }
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={"Đánh giá"}
      style={{ top: 20 }}
      width={700}
      confirmLoading={loading}
      onOk={() => {
        onClose();
      }}
    >
      <div className="filter-container">
        <Space>
          {/* <div className="filter-item">
            <label htmlFor="">Số sao</label>
            <br />
            <Select
              allowClear
              style={{ width: 150 }}
              onChange={(star) => {
                query.star = star;
                setQuery({ ...query });
              }}
            >
              <Option value={1}>1 sao</Option>
              <Option value={2}>2 sao</Option>
              <Option value={3}>3 sao</Option>
              <Option value={4}>4 sao</Option>
              <Option value={5}>5 sao</Option>
            </Select>
          </div> */}

          {/* <div className="filter-item">
            <label htmlFor="">Hình ảnh</label>
            <br />
            <Select
              allowClear
              style={{ width: 150 }}
              onChange={(val) => {
                query.isHasImage = val;
                setQuery({ ...query });
              }}
            >
              <Option value={true}>Có</Option>
              <Option value={false}>Không</Option>
            </Select>
          </div> */}

          <div className="filter-item btn">
            <Button
              onClick={fetchData}
              type="primary"
              icon={<SearchOutlined />}
            >
              Tìm kiếm
            </Button>
          </div>
        </Space>
      </div>
      <Spin spinning={loading}>
        <Table pagination={false} rowKey="id" dataSource={data}>
          <Column
            title="Khách hàng"
            dataIndex="username"
            key="username"
            render={(text, record: ProductRate) => {
              return (
                <div>
                  <div>
                    <Button
                      style={{ padding: 0 }}
                      type="link"
                      href={`tel:${record.customer?.phone}`}
                    >
                      {record.customer?.phone}
                    </Button>
                  </div>

                  <div>
                    <span>
                      {record.customer?.firstName} {record.customer?.lastName}
                    </span>
                  </div>

                  <div>
                    <span>{record.customer?.address}</span>
                  </div>
                </div>
              );
            }}
          />
          <Column
            title="Bình luận"
            render={(text, record: ProductRate) => (
              <div>
                {record.images && (
                  <Image src={$url(record.images?.[0]?.url)} width={80} />
                )}
                <br />
                <Rate defaultValue={record.star} disabled />
                <br />
                <span>{record.content}</span>
              </div>
            )}
          />

          <Column
            title="Thao tác"
            key="action"
            render={(text, record: ProductRate) => (
              <span>
                <Popconfirm
                  placement="top"
                  title="Xác nhận xóa bình luận này?"
                  cancelText="Không"
                  okText="Xóa"
                  onConfirm={() => {
                    handleDelete(record);
                  }}
                >
                  <Button danger>Xóa</Button>
                </Popconfirm>
              </span>
            )}
          />
        </Table>

        <Pagination
          currentPage={query.page}
          total={total}
          onChange={({ limit, page }) => {
            query.page = page;
            query.limit = limit;
            setQuery({ ...query });
          }}
        />
      </Spin>
    </Modal>)
  );
};
